<template>
  <div class="" @click="openRow"
        :class="{'stat-ligne' : isTotal, 'is-radius-large' : !isTotal}">
    <div v-if="!isTotal" class="is-radius-top-left-large is-radius-top-right-large"
        :class="{ 'over' : orderedSellers.length }"></div>
    <div class="columns is-gapless">
      <div class="column columns is-2 is-vcentered">
        <div class="column is-narrow is-padding-left-small is-paddingless-right is-padding-top-small is-padding-bottom-small">
          <swatches class="colorPicker" v-if="!isTotal" v-model="color"
                    @input="setColor" shapes="circles"
                    :trigger-style="{width: '30px', height: '30px'}"
                    :swatch-size="30"
                    :colors="'material-basic'">
          </swatches>
        </div>
        <div class="column is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <strong class="entityName">{{entity.name}}</strong><br>
          <span v-if="data.sellers && data.sellers.length > 1">
          <span class="is-size-6">({{sellers.length}} vendeurs)</span>
        </span>
        </div>
        <!--
        <div class="column is-paddingless-right is-padding-left-small">
        </div> -->
      </div>
      <div class="columns column is-6 is-vcentered">
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.reservationsCount" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.reservationsCount && previousData.reservationsCount"
                            :tooltip-content="'Période précedente : ' + previousData.reservationsCount"
                            :old-value="previousData.reservationsCount"
                            :new-value="data.reservationsCount">

          </variation-indice>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.actesCount" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.actesCount && previousData.actesCount"
                            :tooltip-content="'Période précedente : ' + previousData.actesCount"
                            :old-value="previousData.actesCount"
                            :new-value="data.actesCount">
          </variation-indice>
        </div>
        <div
          class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.cancelCount" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.cancelCount && previousData.cancelCount"
                            :tooltip-content="'Période précedente : ' + previousData.cancelCount"
                            :old-value="previousData.cancelCount"
                            :new-value="data.cancelCount">
          </variation-indice>
        </div>
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.CA" :euro="true" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.CA && previousData.CA"
                            :tooltip-content="`Période précedente : ${previousData.CA.toLocaleString()} ${currency}`"
                            :old-value="previousData.CA"
                            :new-value="data.CA">
          </variation-indice>
        </div>
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.avgCA" :euro="true" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.avgCA && previousData.avgCA"
                            :tooltip-content="`Période précedente : ${previousData.avgCA.toLocaleString()} ${currency}`"
                            :old-value="previousData.avgCA"
                            :new-value="data.avgCA">
          </variation-indice>
        </div>
      </div>
      <div class="columns column is-4 is-vcentered is-border-left" :class="{'has-bg-white is-radius-top-right-large is-radius-bottom-right-large': !isTotal}">
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.COM" :euro="true" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.COM && previousData.COM"
                            :tooltip-content="`Période précedente : ${previousData.COM.toLocaleString()} ${currency}`"
                            :old-value="previousData.COM"
                            :new-value="data.COM">
          </variation-indice>
        </div>
        <div
          class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.avgCOM" :euro="true" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.avgCOM && previousData.avgCOM"
                            :tooltip-content="`Période précedente : ${previousData.avgCOM.toLocaleString()} ${currency}`"
                            :old-value="previousData.avgCOM"
                            :new-value="data.avgCOM">
          </variation-indice>
        </div>
        <div v-if="displayRemuneration"
          class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <stat-value :value="data.avgRemuneration" :percentage="true" :total="isTotal"></stat-value>
          <br>
          <variation-indice v-if="previousData && data.avgRemuneration && previousData.avgRemuneration"
                            :tooltip-content="'Période précedente : ' + previousData.avgRemuneration.toLocaleString() + ' %'"
                            :old-value="previousData.avgRemuneration"
                            :new-value="data.avgRemuneration">
          </variation-indice>
        </div>
        <div class="column has-text-right is-2">
          <button v-if="!isTotal && canBeRemove" @click="remove" class="button is-circle is-small">
            <i class="fal fa-times"></i>
          </button>
        </div>
      </div>
    </div>


    <div class="stat-detail is-size-6 is-border-top is-border-dashed" v-if="isOpen">
      <div v-for="seller in orderedSellers" class="columns is-gapless" v-if="seller.sales">
        <div class="column is-2">
          <div class="column is-paddingless-right is-padding-left-large is-padding-bottom-small is-padding-top-small ">
             <router-link :to="{name: 'UserVue', params: {id: seller.pk}}">
              <a class="is-margin-left is-padding-left">{{seller.name}}<br></a>
            </router-link>
          </div>
        </div>
        <div class="columns column is-6">
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.reservationsCount" :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.actesCount" :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.cancelCount" :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.CA" :euro="true" :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.avgCA" :euro="true" :total="isTotal"></stat-value>
          </div>
        </div>
        <div class="columns column is-4 has-bg-light is-radius-bottom-right-large">
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.COM" :euro="true" :total="isTotal"></stat-value>
          </div>
          <div
            class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.avgCOM" :euro="true" :total="isTotal"></stat-value>
          </div>
          <div v-if="displayRemuneration"
            class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
            <stat-value :value="seller.sales.avgRemuneration" :percentage="true" :total="isTotal"></stat-value>
          </div>
          <div class="columns column is-2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swatches from 'vue-swatches'
  import { orderBy } from 'lodash'
  import VariationIndice from '../../utils/VariationIndice'
  import StatValue from '../../utils/StatValue'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SellerEntityRow',
    components: {
      VariationIndice,
      Swatches,
      StatValue
    },
    props: {
      entity: {
        type: Object,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      },
      isTotal: {
        type: Boolean,
        default: false
      },
      canBeRemove: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        color: null
      }
    },
    computed: {
      ...mapGetters(['displayRemuneration']),
      entityColor () {
        return this.entity._color
      },
      inlineStyle () {
        return {
          backgroundColor: this.entityColor
        }
      },
      orderedSellers () {
        return orderBy(this.sellers, ['seller.first_name', 'seller.last_name'])
      },
      sellers () {
        if ('sellers' in this.data) {
          return this.data.sellers
        } else {
          return []
        }
      },
      sellersName () {
        return this.sellers.map(x => {
          return x.seller.first_name + ' ' + x.seller.last_name
        }).join(', ')
      },
      data () {
        return this.entity.data
      },
      previousData () {
        return this.entity.previousData
      },
      currency () {
        return this.$currency
      }
    },
    methods: {
      openRow () {
        if (!this.orderedSellers || !this.orderedSellers.length) return
        this.$emit('open', this.entity)
      },
      remove () {
        this.$emit('remove', this.entity)
      },
      setColor (value) {
        this.$emit('setColor', this.entity, value)
      }
    },
    created () {
      this.color = this.entity._color
    }
  }
</script>

<style>
  .wrapper {
    display: flex;
    align-items: center;
  }

  .entityNamex {
    padding-left: 5%;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/statistics/seller/SellerEntityRow.vue